import clsx from 'clsx';
import React, { Suspense, lazy } from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';
import { LeadTypes } from '@utils/enums';

const Paywall = lazy(() => import('@components/Paywall'));

const GraphicsSearchPagePaywall = ({ paywallData, shouldShowPaywall }) => {
  const hydrated = useServerSideRendering();

  return (
    <>
      {hydrated && shouldShowPaywall && (
        <Suspense>
          <div
            className={clsx('sticky -bottom-px z-50 mt-0 w-full bg-white sm:bg-grayscale-charcoal')}
            data-testid="charts-paywall-container"
          >
            <Paywall leadType={LeadTypes.ChartsLead} {...paywallData} />
          </div>
        </Suspense>
      )}
      {shouldShowPaywall && (
        <div className="absolute inset-0 -top-48 bg-[linear-gradient(to_bottom,_rgb(47_53_56_/_0)_0%,_rgb(47_53_56_/_0.9)_80%,_rgb(47_53_56_/_1)_100%)]" />
      )}
    </>
  );
};

export default GraphicsSearchPagePaywall;
